import { css } from "@/utils/css";
import { __ } from "@wordpress/i18n";
import { v4 as uuid } from "uuid";
import { useState } from "react";

type Props = {
    label?: string;
    help?: string | React.ReactNode;
    value?: string;
    className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export function CodeCopy({ label, help, value, className, ...rest }: Props) {
    const id = uuid();
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (!value) return;

        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = value;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <div className={css(className || "")} {...rest}>
            {label && (
                <label htmlFor={id} className={css("form-label")}>
                    {label}
                </label>
            )}
            {help && <p className={css("form-help")}>{help}</p>}
            <div className={css("textarea-copy-container mt-2")} style={{ position: 'relative' }}>
                <textarea
                    id={id}
                    readOnly
                    style={{
                        whiteSpace: 'pre',
                        overflow:'auto',
                        wordWrap: 'normal',
                        resize: 'horizontal',
                        padding:'20px 15px',
                        fontFamily:'Consolas, monospace',
                        width:'100%',
                        height:'250px',
                        fontSize:'12px',
                        background:'#272822',
                        color:' #f8f8f2',
                        border:' none',
                        borderRadius:'8px',
                        lineHeight:'1.5',
                        boxShadow:'inset 0 0 10px rgba(0, 0, 0, 0.2)'
                    }}
                    value={value || __("No content to copy", "antimanual")}
                />
                <button
                    type="button"
                    onClick={handleCopy}
                    className={css("copy-button")}
                    style={{
                        position: 'absolute',
                        top: '8px',
                        right: '24px',
                        padding: '4px 8px',
                        background: 'linear-gradient(90deg, #0079FF, #0DB9F2)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '3px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        transition: 'background 0.2s'
                    }}
                    disabled={!value}
                >
                    {copied ? __("Copied!", "antimanual") : __("Copy", "antimanual")}
                </button>
            </div>
        </div>
    );
}
